import React, { useState, useEffect } from 'react';
import api from '../services/api'; // Ajuste o caminho da sua API

// Ícones básicos embutidos
const Icons = {
  Plus: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>,
  Edit: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>,
  Trash: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>,
  Camera: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>,
  Close: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
};

// COMPRESSOR DE IMAGEM NATIVO (Transforma foto pesada em um Base64 leve)
const compressImage = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const MAX_WIDTH = 800; // Tamanho máximo
        const scaleSize = MAX_WIDTH / img.width;
        canvas.width = MAX_WIDTH;
        canvas.height = img.height * scaleSize;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        // Comprime para JPEG com 70% de qualidade
        resolve(canvas.toDataURL('image/jpeg', 0.7)); 
      };
    };
  });
};

export default function Produtos() {
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({ id: null, nome: '', categoria: 'Lente', preco: '', estoque: '', descricao: '', imagemBase64: '' });

  const fetchProdutos = async () => {
    try {
      const res = await api.get('/produtos');
      setProdutos(res.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchProdutos(); }, []);

  const openModal = (prod = null) => {
    if (prod) {
      setForm({ id: prod._id, nome: prod.nome, categoria: prod.categoria, preco: prod.preco, estoque: prod.estoque, descricao: prod.descricao, imagemBase64: prod.imagemBase64 || '' });
    } else {
      setForm({ id: null, nome: '', categoria: 'Lente', preco: '', estoque: '', descricao: '', imagemBase64: '' });
    }
    setModalOpen(true);
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) return alert('Selecione apenas imagens.');
    
    // Comprime e salva no state
    const compressedBase64 = await compressImage(file);
    setForm({ ...form, imagemBase64: compressedBase64 });
  };

  const saveProduto = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = { ...form, preco: Number(form.preco), estoque: Number(form.estoque) };
      
      if (form.id) await api.put(`/produtos/${form.id}`, payload);
      else await api.post('/produtos', payload);
      
      setModalOpen(false);
      fetchProdutos();
    } catch (e) { alert("Erro ao salvar produto"); }
    finally { setSaving(false); }
  };

  const deleteProduto = async (id) => {
    if(!window.confirm("Deseja realmente apagar este produto?")) return;
    try {
      await api.delete(`/produtos/${id}`);
      fetchProdutos();
    } catch (e) { alert("Erro ao apagar"); }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <h2 style={styles.title}>Estoque e Produtos</h2>
          <p style={styles.subtitle}>Gerencie lentes, acessórios e produtos diversos.</p>
        </div>
        <button onClick={() => openModal()} style={styles.addBtn}><Icons.Plus /> Novo Produto</button>
      </div>

      {loading ? (
        <div style={{textAlign: 'center', padding: 50, color: '#64748b'}}>Carregando produtos...</div>
      ) : (
        <div style={styles.grid}>
          {produtos.map(prod => (
            <div key={prod._id} style={styles.card}>
              <div style={styles.imgContainer}>
                {prod.imagemBase64 ? (
                  <img src={prod.imagemBase64} alt={prod.nome} style={styles.img} />
                ) : (
                  <div style={styles.noImg}><Icons.Camera /></div>
                )}
                <span style={styles.badge}>{prod.categoria}</span>
              </div>
              <div style={styles.cardBody}>
                <h3 style={styles.prodName}>{prod.nome}</h3>
                <p style={styles.prodDesc}>{prod.descricao || 'Sem descrição'}</p>
                <div style={styles.prodInfo}>
                  <strong style={{color: '#059669', fontSize: 18}}>R$ {Number(prod.preco).toFixed(2)}</strong>
                  <span style={{fontSize: 12, color: '#64748b', fontWeight: 600}}>Estoque: {prod.estoque} un</span>
                </div>
                <div style={styles.actions}>
                  <button onClick={() => openModal(prod)} style={{...styles.actionBtn, color: '#4f46e5'}}><Icons.Edit /> Editar</button>
                  <button onClick={() => deleteProduto(prod._id)} style={{...styles.actionBtn, color: '#ef4444'}}><Icons.Trash /> Excluir</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* MODAL DE CADASTRO */}
      {modalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 20}}>
              <h3 style={{margin: 0, fontSize: 20}}>{form.id ? 'Editar Produto' : 'Novo Produto'}</h3>
              <button onClick={() => setModalOpen(false)} style={{background: 'none', border: 'none', cursor: 'pointer'}}><Icons.Close /></button>
            </div>

            <form onSubmit={saveProduto} style={{display: 'flex', flexDirection: 'column', gap: 15}}>
              
              <div style={{textAlign: 'center', marginBottom: 10}}>
                <label htmlFor="foto-upload" style={{cursor: 'pointer', display: 'inline-block'}}>
                  {form.imagemBase64 ? (
                    <img src={form.imagemBase64} alt="Preview" style={{width: 120, height: 120, objectFit: 'cover', borderRadius: 16, border: '2px solid #e2e8f0'}} />
                  ) : (
                    <div style={{width: 120, height: 120, borderRadius: 16, background: '#f8fafc', border: '2px dashed #cbd5e1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8'}}><Icons.Camera /></div>
                  )}
                  <span style={{display: 'block', fontSize: 12, color: '#4f46e5', fontWeight: 700, marginTop: 8}}>Adicionar Foto</span>
                </label>
                <input id="foto-upload" type="file" accept="image/*" onChange={handleImageUpload} style={{display: 'none'}} />
              </div>

              <div style={{display: 'flex', gap: 15}}>
                <div style={{flex: 2}}>
                  <label style={styles.label}>Nome do Produto</label>
                  <input required value={form.nome} onChange={e=>setForm({...form, nome: e.target.value})} style={styles.input} />
                </div>
                <div style={{flex: 1}}>
                  <label style={styles.label}>Categoria</label>
                  <select value={form.categoria} onChange={e=>setForm({...form, categoria: e.target.value})} style={styles.input}>
                    <option value="Lente">Lente</option>
                    <option value="Armação">Armação</option>
                    <option value="Acessório">Acessório</option>
                    <option value="Limpeza">Limpeza</option>
                    <option value="Diversos">Diversos</option>
                  </select>
                </div>
              </div>

              <div style={{display: 'flex', gap: 15}}>
                <div style={{flex: 1}}>
                  <label style={styles.label}>Preço (R$)</label>
                  <input required type="number" step="0.01" value={form.preco} onChange={e=>setForm({...form, preco: e.target.value})} style={styles.input} />
                </div>
                <div style={{flex: 1}}>
                  <label style={styles.label}>Qtd. em Estoque</label>
                  <input required type="number" value={form.estoque} onChange={e=>setForm({...form, estoque: e.target.value})} style={styles.input} />
                </div>
              </div>

              <div>
                <label style={styles.label}>Descrição (Opcional)</label>
                <textarea rows="3" value={form.descricao} onChange={e=>setForm({...form, descricao: e.target.value})} style={styles.input}></textarea>
              </div>

              <button type="submit" disabled={saving} style={styles.submitBtn}>
                {saving ? 'Salvando...' : 'Salvar Produto'}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { fontFamily: '"Plus Jakarta Sans", sans-serif', maxWidth: 1200, margin: '0 auto', padding: '32px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 },
  title: { margin: 0, fontSize: 26, fontWeight: 800, color: '#0f172a' },
  subtitle: { margin: '4px 0 0 0', fontSize: 14, color: '#64748b' },
  addBtn: { display: 'flex', alignItems: 'center', gap: 8, background: '#4f46e5', color: '#fff', border: 'none', padding: '12px 24px', borderRadius: 12, fontWeight: 800, cursor: 'pointer', boxShadow: '0 4px 10px rgba(79, 70, 229, 0.2)' },
  
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: 24 },
  card: { background: '#fff', borderRadius: 20, border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 4px 6px rgba(0,0,0,0.02)', transition: '0.3s' },
  imgContainer: { height: 180, background: '#f8fafc', position: 'relative' },
  img: { width: '100%', height: '100%', objectFit: 'cover' },
  noImg: { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#cbd5e1' },
  badge: { position: 'absolute', top: 12, right: 12, background: 'rgba(15, 23, 42, 0.7)', color: '#fff', fontSize: 11, fontWeight: 800, padding: '4px 10px', borderRadius: 20, backdropFilter: 'blur(4px)' },
  cardBody: { padding: 20 },
  prodName: { margin: '0 0 4px 0', fontSize: 16, fontWeight: 800, color: '#0f172a' },
  prodDesc: { margin: 0, fontSize: 12, color: '#64748b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  prodInfo: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, paddingTop: 16, borderTop: '1px solid #f1f5f9' },
  
  actions: { display: 'flex', gap: 10, marginTop: 16 },
  actionBtn: { flex: 1, background: '#f8fafc', border: 'none', padding: '8px', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 },
  
  modalOverlay: { position: 'fixed', inset: 0, background: 'rgba(15, 23, 42, 0.7)', zIndex: 999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)' },
  modalContent: { background: '#fff', width: '100%', maxWidth: 500, padding: 32, borderRadius: 24, boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)' },
  label: { display: 'block', fontSize: 12, fontWeight: 800, color: '#64748b', marginBottom: 6 },
  input: { width: '100%', padding: '12px 16px', borderRadius: 12, border: '1px solid #cbd5e1', fontSize: 14, background: '#f8fafc', outline: 'none' },
  submitBtn: { width: '100%', padding: 16, borderRadius: 12, background: '#10b981', color: '#fff', border: 'none', fontWeight: 800, fontSize: 15, cursor: 'pointer', marginTop: 10 }
};